module.exports = __webpack_public_path__ + "static/pythagorassystems-55f0d55a633b38f93ab1115e63f3cfde.jpg";